import React from 'react';
import {View, StyleSheet, Text} from 'react-native';
import {TextStyles, Colors} from '../index';
import {ComponentProps} from './ComponentProps';

interface HelperProps extends ComponentProps {
  text: string | null;
}

export const HelperNeutralDarker = (props: HelperProps) => {
  return <Helper {...{...props, color: Colors.neutralDarker}} />;
};

export const HelperInvalid = (props: HelperProps) => {
  return <Helper {...{...props, color: Colors.error}} />;
};

export const HelperWarning = (props: HelperProps) => {
  return <Helper {...{...props, color: Colors.warning}} />;
};

export const HelperDanger = (props: HelperProps) => {
  return <Helper {...{...props, color: Colors.danger}} />;
};

interface HelperComponentProps extends HelperProps {
  color: string;
}

const Helper = (props: HelperComponentProps) => {
  const textStyle = [TextStyles.textMediumS, {color: props.color}];
  return (
    <View style={props.containerStyle}>
      <View style={styles.container}>
        <Text testID={props.testID} style={textStyle}>
          {props.text}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {minHeight: 30, flexDirection: 'row', alignItems: 'center'},
});
